export default __webpack_public_path__ + "static/Upbit-607ce7cc62a646277d67d1d10935f9a9.png";